import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import ProductCard from "../../components/cards/ProductCard";
import AppContext from "../../context/AppContext";
import { onPageHeadSEO, scrollToTop } from "../../helper/HelperFunctions";
import MasterLayout from "../../layout/MasterLayout";
import {
  MdOutlinePhoneIphone,
  MdOutlineLaptop,
  MdOutlineDevicesOther,
} from "react-icons/md";
import { TbDeviceIpad } from "react-icons/tb";

const Accessory = () => {
  const { baseUrl, settingsForSlick } = useContext(AppContext);
  const [products, setProducts] = useState([]);
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState("mobile");
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const getAllProducts = (mobile_type, category_id, selectedSubType) => {
    //SorA ka mtlb ha Specific ya ALL
    setIsLoadingProducts(true);
    const formData = new FormData();
    formData.append("type", mobile_type);
    formData.append("category_id", category_id);
    formData.append("sub_type", selectedSubType);

    axios
      .post(`${baseUrl}/api/guest/getProducts`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data);
        setProducts(resp.data.products);
        setIsLoadingProducts(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingProducts(false);
      });
  };

  const getAllCategories = () => {
    const formData = new FormData();
    formData.append("all", "yes");

    axios
      .post(`${baseUrl}/api/guest/getAllCategories`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((resp) => {
        console.log(resp.data);
        setAllCategories(resp.data.categories);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    scrollToTop();
    getAllProducts("phone", "0", selectedSubMenu);
    getAllCategories();
    onPageHeadSEO(
      "FixTech Expert",
      "FixTechExpert - book your repair with upto 30% discount.",
      "FixtechExpert,Discounted Repairing"
    );
  }, []);

  return (
    <MasterLayout>
      {/* MOBILE BRANDS */}

      {/* What we offer you - Cars */}
      <Container fluid className="m-0">
        {/* <img src={logo} className="img img-fluid d-lg-none" /> */}
        <Row className="m-0">
          <Col lg={3} sm={12}>
            <h4 className="poppins-semiBold px-5 txt-skyBlue mt-3">
              Categories
            </h4>
            <ul className="d-none d-lg-block categoryOrBrandlist">
              {allCategories.map((item) => {
                return (
                  <li
                    onClick={() => {
                      setSelectedCategoryId(item.id);
                      getAllProducts("accessory", item.id, selectedSubMenu);
                    }}
                    className={
                      selectedCategoryId == item.id
                        ? "categoryOrBrandActivelistItem shadow-lg"
                        : "categoryOrBrandlistItem shadow-lg"
                    }
                  >
                    <img
                      src={`${baseUrl}/storage/${item.image}`}
                      style={{
                        height: 40,
                        width: 40,
                        borderRadius: "100%",
                        objectFit: "contain",
                      }}
                    />
                    &nbsp;&nbsp;{item.name}
                  </li>
                );
              })}
            </ul>

            <div className="d-lg-none">
              <Slider {...settingsForSlick}>
                {allCategories.map((item) => {
                  return (
                    <li
                      onClick={() => {
                        getAllProducts("accessory", item.id, selectedSubMenu);
                        setShowSideMenu(false);
                      }}
                      className="categoryOrBrandlistItem-mobile text-center shadow-sm"
                    >
                      <img
                        src={`${baseUrl}/storage/${item.image}`}
                        style={{
                          height: 25,
                          width: "100%",
                          borderRadius: "100%",
                          objectFit: "contain",
                          backgroundColor: "white",
                        }}
                      />

                      <p style={{ margin: "5px 0px" }}>{item.name}</p>
                    </li>
                  );
                })}
              </Slider>
            </div>
          </Col>
          <Col lg={9} sm={12}>
            <Row>
              <Col lg={12} md={12} sm={12}>
                <ButtonGroup aria-label="Basic example" style={{width:"100%"}}>
                  <Button
                    style={{ fontSize: isDesktopOrLaptop ? 14 : 9,backgroundColor: selectedSubMenu == "mobile" ? "#1794dc" : "#0c2f53",borderWidth:0}}
                    onClick={() => {
                      setSelectedSubMenu("mobile");
                      getAllProducts("accessory", "0", "mobile");
                    }}
                    // variant={selectedSubMenu == "mobile" ? "danger" : "light"}
                  >
                    <MdOutlinePhoneIphone className="d-none d-lg-inline" /> &nbsp; Mobiles
                  </Button>
                  <Button
                    style={{ fontSize: isDesktopOrLaptop ? 14 : 9,backgroundColor: selectedSubMenu == "laptop" ? "#1794dc" : "#0c2f53",borderWidth:0}}
                    onClick={() => {
                      setSelectedSubMenu("laptop");
                      getAllProducts("accessory", "0", "laptop");
                    }}
                    // variant={selectedSubMenu == "laptop" ? "danger" : "light"}
                  >
                    <MdOutlineLaptop className="d-none d-lg-inline" /> &nbsp; Laptops
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
            <Row className="pt-5">
              {isLoadingProducts ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50vh",
                  }}
                >
                  <Spinner size="lg" />
                </div>
              ) : products.length > 0 ? (
                products.map((item, index) => (
                  <Col
                    sm={4}
                    xs={6}
                    md={4}
                    lg={3}
                    className="m-0 p-0 d-flex justify-content-center"
                    key={index}
                  >
                    <ProductCard item={item} />
                  </Col>
                ))
              ) : (
                <h1 className="poppins-semiBold txt-skyBlue text-center my-5">
                  No Products Found
                </h1>
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    </MasterLayout>
  );
};

export default Accessory;
